import React, { useEffect, useState } from "react";

export default function AdvisorModal({ onClose }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Trigger animation after mount
    setShow(true);
  }, []);

  const handleClose = () => {
    setShow(false);
    setTimeout(() => {
      onClose();
    }, 400); // matches transition duration
  }; 

  return (
    <div
      className={`tw-fixed tw-inset-0 tw-bg-black tw-bg-opacity-50 tw-flex tw-items-center tw-justify-center tw-z-50 tw-transition-opacity tw-duration-300 ${
        show ? "tw-opacity-100 tw-visible" : "tw-opacity-0 tw-invisible"
      }`}
    >
      <div
        className={`tw-bg-white tw-rounded-3xl tw-p-8 tw-max-w-md tw-w-full tw-mx-4 tw-transform tw-transition-transform tw-duration-300 ${
          show ? "tw-scale-100" : "tw-scale-95"
        }`}
      >
        <button
          onClick={handleClose}
          className="tw-absolute tw-top-4 tw-right-4 tw-text-gray-400 hover:tw-text-gray-600 tw-text-2xl tw-bg-transparent"
        >
          &times;
        </button>

        <h3 className="tw-text-2xl tw-font-bold tw-text-fintoo-blue tw-mb-6">
          Talk to an Advisor
        </h3>
        <p className="tw-text-gray-600 tw-mb-6">
          Enter your details and our advisor will connect with you shortly.
        </p>

        <form className="tw-space-y-4">
          <input
            type="text"
            placeholder="Full Name"
            className="tw-w-full tw-px-4 tw-py-3 tw-border tw-border-solid tw-border-gray-300 tw-rounded-xl focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-fintoo-orange tw-transition-all"
          />
          <input
            type="email"
            placeholder="Email"
            className="tw-w-full tw-px-4 tw-py-3 tw-border tw-border-solid tw-border-gray-300 tw-rounded-xl focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-fintoo-orange tw-transition-all"
          />
          <input
            type="tel"
            placeholder="Phone Number"
            className="tw-w-full tw-px-4 tw-py-3 tw-border tw-border-solid tw-border-gray-300 tw-rounded-xl focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-fintoo-orange tw-transition-all"
          />

          <button
            type="submit"
            className="tw-w-full tw-bg-fintoo-orange tw-text-white tw-py-4 tw-rounded-xl tw-font-semibold tw-text-lg hover:tw-from-orange-600 hover:tw-to-orange-700 tw-transition-all tw-transform hover:tw-scale-[1.02]"
          >
            Submit
          </button>

          <button
            type="button"
            onClick={handleClose}
            className="tw-w-full tw-border tw-border-solid tw-border-gray-300 tw-text-gray-600 tw-py-3 tw-rounded-xl tw-font-medium hover:tw-bg-gray-50 tw-transition-all"
          >
            Cancel
          </button>
        </form>

        <div className="tw-flex tw-items-center tw-justify-center tw-mt-6 tw-text-sm tw-text-gray-500">
          <i className="fa-solid fa-lock tw-mr-2"></i>
          <span>Your information is safe with us</span>
        </div>
      </div>
    </div>
  );
}
